import {Injectable} from '@angular/core';
import {handleResult} from "@share/utils/handle-result";
import {Result} from "@domain/common/http/result";
import {FormulaireHttpService} from "@services/admin/parametre/formulaire/formulaire-http.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ParamOm} from "@domain/admin/parametre/formulaire/param-om";
import {finalize} from "rxjs/operators";
import {MessageNotification} from "@domain/admin/parametre/formulaire/message-notification";

/**
 * Service du formulaire OM
 *
 * @author Lionel Gimenez
 * @date 08/09/2025
 */
@Injectable()
export class FormulaireOmService {
    /** Indicateur pour savoir si on est en cours de sauvegarde */
    isSaving: boolean = false;

    /** Paramètres OM */
    paramOM: ParamOm;

    /** Liste des notifications */
    messageNotificationListe: MessageNotification[];

    /**
     * Constructeur
     */
    constructor(
        private formulaireHttpService: FormulaireHttpService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    /**
     * Charge les données
     */
    load(): void {
        this.formulaireHttpService.loadOm()
            .pipe(handleResult(this.translateService, this.toastrService, null, 'global.errors.generic'))
            .subscribe((result: Result) => {
                this.paramOM = result.data.param;

                this.messageNotificationListe = result.data.listeNotification;

                //On crée une ligne custom pour aucun dans les notifications
                const notification: MessageNotification = {
                    idMessage: 0,
                    titre: this.translateService.instant("admin.parametres.formulaire.om.mailOption.aucun")
                }
                this.messageNotificationListe.push(notification);
            })
    }

    /**
     * Sauvegarde les données
     */
    save(): void {
        //Indicateur de sauvegarde
        this.isSaving = true;

        //Sauvegarde
        this.formulaireHttpService.saveOm(this.paramOM)
            .pipe(
                handleResult(this.translateService, this.toastrService),
                finalize(() => this.isSaving = false))
            .subscribe((result: Result) => {
                //Refresh
                this.load();
            });
    }
}
